"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CountryValidator = void 0;
const ibantools = require("ibantools");
class CountryValidator {
    constructor(channel) {
        this.channel = channel;
    }
    isValidIBAN(str, strictCountryCheck = false) {
        if (strictCountryCheck && typeof str === 'string' && !str.startsWith(this.channel ?? '')) {
            return false;
        }
        return ibantools.isValidIBAN(str);
    }
}
exports.CountryValidator = CountryValidator;
